import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AdmissionService } from 'src/app/private/services/admission.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-admission',
  imports: [SharedModule],
  templateUrl: './delete-admission.component.html',
  styleUrl: './delete-admission.component.scss'
})
export class DeleteAdmissionComponent {


  @Output() closeDialog = new EventEmitter<any>();
  @Input() editLeadData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: AdmissionService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete() {
    this.isLoading = true;

    const payload = {
      admission_ids: [this.editLeadData.admission_id],
      organization_id: this.localStorage.getOrganizationId()
    };

    this.api.bulkDeleteAdmission(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead deleted successfully' });
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
        this.isLoading = false;
      }
    }
    );

  }

}
